import React, { useEffect, useState } from 'react';
import PollResults from '../../components/PollResults/PollResults';
import './Results.scss';
import {withRouter} from 'react-router-dom'
import axios from 'axios'
import {API_URL} from '../../utils/axios'

const Results = ({match}) => {
    const [pollResults, setPollResults] = useState([]);
    useEffect(()=> {
        axios.defaults.headers['foodrtoken'] = localStorage.getItem("token");
        axios.get(API_URL + '/poll/get/' + match.params.id + "/results").then(response => setPollResults(response.data)).catch(error => console.log(error))
    },[match])
    return (
            <div className="results">
                <PollResults pollResults={pollResults}/>
            </div>
        
    );
};

export default withRouter(Results);